export default {"src":"/_next/static/media/isotype-fill.3a0b80da.svg","height":113,"width":112};